/* The business copy on the demo page. YOURS: `copier update` never touches this file.
 *
 * There is no live read-out any more: the agent holds the call in one conversation and
 * records only a booking, a message or a safety warning, and the Handset dashboard is where
 * the owner sees what a call produced.
 */

// The four demo openers. Each one is a caller the current setup loses, written in the
// words that caller would actually use.
export const OPENERS = [
  "My car won't start and I need it for work tomorrow.",
  "I dropped my car off Monday and nobody's called me.",
  "My rego's due Friday, can you do a pink slip?",
  "How much to look at a check engine light on a Golf?",
];

// The panel under the openers. The only person who ever opens this page is the owner, and
// on it they are the caller - so this must not talk as though customers are ringing in.
export const PITCH = {
  title: "What this is",
  lines: [
    "Your front desk, answering. Talk to it like a customer would. It knows every service "
      + "on your website, your hours, the pink slip fees and how a booking works here.",
    "It never quotes a repair, never says what's wrong with a car, and never promises when "
      + "one will be ready. It books the day the car comes in, around what's already booked "
      + "and your public holidays, and takes a message when a person has to ring back.",
    "Every call shows up in your dashboard: who rang, what car, what was agreed, and who "
      + "still owes them a phone call.",
  ],
};
